import { MarkerUtils } from "../MarkerUtils";

type PixelBounds = {
    northEast: google.maps.Point;
    southWest: google.maps.Point;
}

export const filterMarkersToPaddedViewport = (
    map: google.maps.Map,
    mapCanvasProjection: google.maps.MapCanvasProjection,
    lstPoints: google.maps.Data.Feature[],
    viewportPaddingPixels: number
): google.maps.Data.Feature[] => {
    const extendedMapBounds = extendBoundsToPaddedViewport(
        map.getBounds(),
        mapCanvasProjection,
        viewportPaddingPixels
    );

    return lstPoints.filter((point) => extendedMapBounds.contains(MarkerUtils.getPosition(point)));
}

export const extendBoundsToPaddedViewport = (
    bounds: google.maps.LatLngBounds,
    projection: google.maps.MapCanvasProjection,
    numPixels: number
): google.maps.LatLngBounds => {
    const { northEast, southWest } = latLngBoundsToPixelBounds(
        bounds,
        projection
    );

    const extendedPixelBounds = extendPixelBounds(
        { northEast, southWest},
        numPixels
    );

    return pixelBoundsToLatLngBounds(extendedPixelBounds, projection);
}

export const getPaddedViewport = (
    bounds: google.maps.LatLngBounds,
    projection: google.maps.MapCanvasProjection,
    pixels: number
): [number, number, number, number] => {
    const extended = extendBoundsToPaddedViewport(bounds, projection, pixels);

    const ne = extended.getNorthEast();
    const sw = extended.getSouthWest();

    return [sw.lng(), sw.lat(), ne.lng(), ne.lat()];
}

export const distanceBetweenPoints = (
    p1: google.maps.LatLngLiteral,
    p2: google.maps.LatLngLiteral
): number => {
    const R = 6371; //Earth radius in km
    const dLat = ((p2.lat - p1.lat) * Math.PI) / 180;
    const dLon = ((p2.lng - p1.lng) * Math.PI) / 180;
    const sinDLat = Math.sin(dLat / 2);
    const sinDLon = Math.sin(dLon / 2);
    const a =
    sinDLat * sinDLat +
    Math.cos((p1.lat * Math.PI) / 180) *
      Math.cos((p2.lat * Math.PI) / 180) *
      sinDLon *
      sinDLon;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

const latLngBoundsToPixelBounds = (
    bounds: google.maps.LatLngBounds,
    projection: google.maps.MapCanvasProjection
): PixelBounds => {
    return {
        northEast: projection.fromLatLngToDivPixel(bounds.getNorthEast()),
        southWest: projection.fromLatLngToDivPixel(bounds.getSouthWest()),
    };
}

export const extendPixelBounds = (
    { northEast, southWest }: PixelBounds,
    numPixels: number
): PixelBounds => {
    northEast.x += numPixels;
    northEast.y -= numPixels;

    southWest.x -= numPixels;
    southWest.y += numPixels;

    return { northEast, southWest };
}

export const pixelBoundsToLatLngBounds = (
    { northEast, southWest }: PixelBounds,
    projection: google.maps.MapCanvasProjection
): google.maps.LatLngBounds => {
    const sw = projection.fromDivPixelToLatLng(southWest);
    const ne = projection.fromDivPixelToLatLng(northEast);

    return new google.maps.LatLngBounds(sw, ne);
}